/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description messagedView selectors
 */

import { createSelector } from '@zcode/memoizers'
import uniqueListables from '@zcode/nr/es/shared/utils/uniqueListables'
import type { State } from '@zcode/state-type'
import { compose } from 'redux'

const selectMessagedView = (state: State) => state.messagedView
const selectListablesRecord = (state: State) => state.messagedView.listables

export const selectHasListables = (state: State) => {
  const listables = selectListables(state)
  return !!listables.length
}

export const selectIsLoadingListables = compose(
  (state) => state.fetchingListables,
  selectMessagedView
)

export const selectListables = compose(
  createSelector(
    (state) => state.featured,
    (state) => state.listables,
    (featured, listables) =>
      uniqueListables(featured?.length ? featured.concat(listables) : listables)
  ),
  selectListablesRecord
)

export const selectMatching = compose((state) => state.matching, selectListablesRecord)
